function startsWith(s, search, rawPos) {
    if (!s || typeof s !== 'string')
        return false
    var pos = rawPos > 0 ? rawPos|0 : 0;
    return s.substring(pos, pos + search.length) === search;
}

export default startsWith